// pull in config vars
import * as config from "../config"
import fetch from "isomorphic-fetch"

interface Result {
	// TODO: What is the shape of the returned JSON?
}

export default async function authUser(
	JAM_ID: string,
	otp: string,
	email: string,
): Promise<Result | false> {
	try {
		const res = await fetch(`${config.API_HOSTNAME}/api/otp/auth`, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ otp, email, jamId: JAM_ID }),
		})

		const json = await res.json()

		// set user
		window.localStorage.setItem("jamUser", JSON.stringify(json.user))

		// set cookie
		document.cookie = json.jamFilledCookie

		return json
	} catch (e) {
		return false
	}
}
